module.exports = __webpack_public_path__ + "static/fonts/icomoon.0a74426.eot";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/wangEditorV2/fonts/icomoon.eot?-qdfu1s
// module id = 3552
// module chunks = 6